module.exports = __webpack_public_path__ + "static/cortex-about-apo-min-33a2f68af870755a692c726510a44e6e.png";